import { Box, Flex, Text } from '@chakra-ui/react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

const ActividadesTipo = ({ data, coloresUnicos }) => (
	<Flex justify='center' gap={8} align='center' wrap='wrap'>
		{/* Gráfico circular */}
		<Box flex='1' minW='250px' maxW='400px'>
			<ResponsiveContainer width='100%' height={300}>
				<PieChart>
					<Pie
						data={data.actividadesPorTipo}
						dataKey='valor'
						nameKey='tipo'
						cx='50%'
						cy='50%'
						outerRadius={100}
						label
					>
						{data.actividadesPorTipo.map((entry, index) => (
							<Cell
								key={`cell-${index}`}
								fill={coloresUnicos[index]}
							/>
						))}
					</Pie>
					<Tooltip />
				</PieChart>
			</ResponsiveContainer>
		</Box>

		{/* Leyenda */}
		<Box flexShrink={0}>
			{data.actividadesPorTipo.map((entry, index) => (
				<Flex key={entry.tipo} align='center' mb={2}>
					<Box
						w={3}
						h={3}
						bg={coloresUnicos[index]}
						borderRadius='full'
						mr={2}
					/>
					<Text>{entry.tipo}</Text>
				</Flex>
			))}
		</Box>
	</Flex>
);

export default ActividadesTipo;
